// `video.extend`: live's Video Extend tool (#210): a source video continued by new footage.
// Live stores an extension as EXTEND_VIDEO, which its label map lacks, so its list shows
// no word. The body: the source video and the new footage's length; the resolution where
// the model makes it (not where it follows the source's); never a ratio.
import { VideoExtendQuote, VideoExtendRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.extend"> = {
  type: "video.extend",
  label: "",
  source: "tool",
  pair: "video.extend",
  fields: (draft, advanced) => ({
    type: draft.type,
    model: draft.model,
    outputs: draft.outputs,
    ...(draft.durationSeconds === null ? {} : { duration_seconds: draft.durationSeconds }),
    ...(draft.resolution === null ? {} : { resolution: draft.resolution }),
    ...(draft.sourceVideo === null ? {} : { source_video: draft.sourceVideo }),
    ...(advanced === null ? {} : { advanced }),
  }),
  request: VideoExtendRequest,
  quote: VideoExtendQuote,
};
